import styled from 'styled-components';
import ImgOn from './img-on.png';
import ImgOff from './img-off.png';

interface Props {
  isOn?: boolean;
  onToggle: (bool: boolean) => void;
}

const ToggleButton = styled.img.attrs<Props>(({ isOn, onToggle }) => {
  return {
    src: isOn ? ImgOn : ImgOff,
    onClick: () => onToggle(!isOn),
  };
})<Props>`
  width: 40px;
  height: 20px;
  cursor: pointer;
`;

export default ToggleButton;
